module.exports = __webpack_public_path__ + "b73e5b38d908b6d28f9c3edce915e6de.pdf";